import * as THREE from 'three';

const MINIMUM_PLANAR_HEADING_SQ=.04;

/**
 * Extrae un rumbo horizontal continuo de la orientación del vehículo. Cuando
 * la trompa cruza la vertical durante una voltereta, su proyección reaparece
 * con el signo contrario. En el aire conservamos el hemisferio anterior para
 * que la cámara no interprete ese cruce como un giro instantáneo de 180°.
 */
export function stabilizedChaseHeading(
  orientation,
  fallbackYaw=0,
  previous=null,
  preserveHemisphere=false,
  target=new THREE.Vector3(),
){
  const previousLength=previous?.isVector3?Math.hypot(previous.x,previous.z):0;
  const hasPrevious=previousLength>.0001;
  const previousX=hasPrevious?previous.x/previousLength:0;
  const previousZ=hasPrevious?previous.z/previousLength:0;
  target.set(0,0,-1);
  if(orientation?.isQuaternion)target.applyQuaternion(orientation);
  target.y=0;
  if(target.lengthSq()<MINIMUM_PLANAR_HEADING_SQ){
    if(hasPrevious)return target.set(previousX,0,previousZ);
    return target.set(-Math.sin(fallbackYaw),0,-Math.cos(fallbackYaw)).normalize();
  }
  target.normalize();
  if(
    preserveHemisphere
    &&hasPrevious
    &&target.x*previousX+target.z*previousZ<0
  )target.negate();
  return target;
}

/** La inclinación manual de cámara se aplica sobre el rumbo estabilizado. */
export function chaseCameraAimDirection(
  planarHeading,
  pitch=0,
  target=new THREE.Vector3(),
){
  const safePitch=THREE.MathUtils.clamp(Number(pitch)||0,-Math.PI*.49,Math.PI*.49);
  target.copy(planarHeading).setY(0);
  if(target.lengthSq()<.0001)target.set(0,0,-1);
  target.normalize().multiplyScalar(Math.cos(safePitch));
  target.y=Math.sin(safePitch);
  return target.normalize();
}

/**
 * Mantiene al vehículo encuadrado durante ascensos y caídas rápidas sin
 * volver rígido el desplazamiento horizontal de la cámara de persecución.
 */
export function chaseCameraVerticalProfile(verticalSpeed=0,airborne=false){
  if(!airborne)return {
    positionRate:6.2,
    targetRate:8,
    targetLead:0,
  };
  const urgency=THREE.MathUtils.clamp(Math.abs(verticalSpeed)/8,0,1);
  return {
    positionRate:9+urgency*5,
    targetRate:12+urgency*4,
    targetLead:THREE.MathUtils.clamp(verticalSpeed*.035,-.28,.52),
  };
}
